/**
 * Este componente sirve para aninimar los elementos internos de un contenedor
 * con una animación de desplazamiento hacia arriba. La propiedad de time
 * debe ser definida y los hijos del elemento deben tener data-slide
 * @param {string} time El tiempo en segundos de la animación
 */
class SlideUp extends HTMLElement {
  constructor() {
    super();
    this.time = this.getAttribute("time");
    this.elements = this.querySelectorAll("[data-slide]");
    this.slideup = this.querySelectorAll("[data-slideup]");
    this.init();

    /**
     * Cargar elementos correcos cuando existe algun elemento de ip-data
     * el evento "slideBuild" viene cada que ipdata remueve el atributo hidden
     * de uno de los elementos del slide
     */
    this.addEventListener("slideBuild", function () {
      this.init();
    });
  }
  /**
   * Inicia la animación
   * this.element son todos los elementos con el selector hide-me
   * this.slideup son todos los textos, estén o no dentro de hide-me
   */
  init() {
    if (this.slideup.length == 1) {
      return false;
    }
    /**
     *  Se guardan los elementos del slide en un array y luego se consulta,
     *  si este array es mayor a 1 se hacen las validaciones correspondientes
     *  para armar el slide y su animación.
     */
    this.slideupElements = Array.from(this.slideup);
    if (this.slideupElements.length > 1) {
      /**
       * Por defecto, elementos que no sean el primero vienen con una clase llamada
       * "hidden_start" esta se remueve post creacion del array, de manera que
       * no sean visibles al momento de cargar la pagina.
       */
      this.slideupElements.forEach((slide) => {
        slide.classList.remove("hidden_start");
      });
      /**
       * Se crea un contador con el numero de elementos que tengan la clase "hidden"
       * estos son los elementos que vienen de ipdata, cuando se reinicie la función
       * el contador se modificará para validar cuales se quedarán ocultos antes de
       * crear la animación.
       */
      var hiddenItemsCount = 0;
      this.slideup.forEach((slide) => {
        if (slide.classList.toString().includes("hidden")) {
          hiddenItemsCount++;
        }
      });

      /**
       * Acá comparamos, si el largo del array, finalmente es por lo menos
       * 2 elementos por encima del total de elementos ocultos
       * se va a crear el slide.
       */
      if (this.slideupElements.length >= hiddenItemsCount + 2) {
        /**
         * Tomamos el tamaño del primer elemento
         * para calcular el tamaño del contenedor
         * y  colocamos propiedades de css
         * en el contenedor para que nuestra animación
         * funcione de manera correcta
         */
        this.parentContainer = this.parentElement;
        this.parentContainer.style.overflow = "hidden";
        this.parentContainer.style.height = `${this.calculateHeight()}px`;
        this.setUpClones();
        this.animation();
      }
    }
  }
  /**
   * Esta función calcula el alto del primer elemento
   * más el padding y el margin del mismo
   * @returns {number}
   */
  calculateHeight() {
    this.firstElement = this.slideupElements[0];
    this.firstElementHeight = this.firstElement.offsetHeight;
    const paddingTop = window.getComputedStyle(this.parentContainer, null).getPropertyValue("padding-top").split("px")[0];
    const paddingBottom = window.getComputedStyle(this.parentContainer, null).getPropertyValue("padding-top").split("px")[0];

    return parseInt(this.firstElementHeight) + parseInt(paddingTop) + parseInt(paddingBottom);
  }
  /**
   * Hay que crear un clon del primer elemento
   * para colocarlo de último para dar la sensación
   * de loop infinito
   */
  setUpClones() {
    const firstSlideElement = this.slideupElements[0];
    this.appendChild(firstSlideElement.cloneNode(true));
  }
  /**
   * Se hace la animación de todos los elementos
   * con propiedades de css. Se usa un setInterval
   * con los segundos de la propiedad time
   */
  animation() {
    const filteredMessageItems = this.slideupElements.filter(function(message) {
      return !message.classList.contains('hidden');
    });
    const totalItems = filteredMessageItems.length;
    let count = 1;
    setInterval(() => {
      this.style.transform = `translateY(-${this.firstElementHeight * count}px)`;
      this.style.transition = `transform ${this.time * 1000}ms cubic-bezier(.02,.79,.03,.99) 0s`;
      count++;
      /**
       * Cuando llegamos al último elemento
       * quitamos 10 milisegundos del tiempo original
       * y reseteamos la animación
       * dando la sensación de que es infinita
       */
      if (count > totalItems) {
        count = 1;
        setTimeout(() => {
          this.style.transition = `none`;
          this.style.transform = `translateY(0px)`;
        }, this.time * 990);
      }
    }, this.time * 1000);
  }
}
if (!customElements.get("slide-up")) {
  customElements.define("slide-up", SlideUp);
}
